export interface OtpResponse {
  message: string;
  status: string;
}
